


export const defaultProfileCardConfig = {
    title: 'name',
    cardLabel: '$thisProfileType',
    image: 'avatar.userUploaded'
  }